import Experience from "../Experience";
import Environment from "./Environment";
import Floor from "./Floor";
import CandyHouse from "./CandyHouse";
import SnowTree from "./SnowTree";
import Fence from "./Fence";
import Particles from "./Particles";
import CandyCane from "./CandyCane";
import SantaSleigh from "./SantaSleigh";

export default class World
{
    constructor()
    {
        //Setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        //Wait for ressources
        this.resources.on('loaded', () =>
        {
            this.floor = new Floor()
            this.candyHouse = new CandyHouse()
            this.candyCane = new CandyCane()
            this.snowTree = new SnowTree()
            this.fence = new Fence()
            this.particles = new Particles()
            this.santaSleigh = new SantaSleigh()
            this.environment = new Environment()
        })
    }

    update()
    {
        if(this.particles)
        {
            this.particles.update()
        }
    }
}